export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

export const TITLE_TH_LIST = ["นาย", "นาง", "นางสาว"];
export const TITLE_EN_LIST = ["Mr", "Mrs", "Miss"];

// ---------------- input sanitizers (ใช้กับ onChange) ----------------
export const onlyThai = (s) => s.replace(/[^ก-๙.\- ]/g, "");
export const onlyEng = (s) => s.replace(/[^A-Za-z ]/g, "");
export const onlyEngNoSpace = (s) => s.replace(/[^A-Za-z]/g, "");
export const onlyEngTitle = (s) => s.replace(/[^A-Za-z. ]/g, "");
export const onlyNumber = (s) => s.replace(/[^0-9]/g, "");
export const onlyAlnum = (s) => s.replace(/[^A-Za-z0-9]/g, "");
export const onlyEmail = (s) => s.replace(/[^A-Za-z0-9._%+\-@]/g, "");

// ---------------- เลขบัตรประชาชน ----------------
export const iDCardNumberValidator = (number) => {
  const id = number.replaceAll("-", "");
  if (id.length !== 13) return false;
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(id.charAt(i), 10) * (13 - i);
  }
  return (11 - (sum % 11)) % 10 === parseInt(id.charAt(12), 10);
};

const isBlank = (s) => !s || s.replaceAll(" ", "") === "";

// field ทั้งหมดที่ต้องผ่านการ validate (key = ชื่อ state ใน useRegisterForm = id ของ input)
export const REGISTER_FIELD_KEYS = [
  "titleTh",
  "signatoryStatus",
  "nameTh",
  "surnameTh",
  "nameEng",
  "surnameEng",
  "cid",
  "tel",
  "mobile",
  "email",
  "username",
  "subOrganization",
  "address",
  "bizEmail",
];

/**
 * คืนข้อความ error ของ field นั้น (string ว่าง = ผ่าน)
 * เป็น pure function ใช้ทั้งตอน validate รายช่อง, ตอน submit และตอนคำนวณ isFormValid
 */
export function getRegisterError(key, v, { caRequest = false, requireStatus = false } = {}) {
  switch (key) {
    case "titleTh":
      return v.titleTh ? "" : "กรุณาเลือกคำนำหน้า";

    case "signatoryStatus":
      return requireStatus && !v.signatoryStatus ? "กรุณาเลือกสถานะ" : "";

    case "nameTh":
      return isBlank(v.nameTh) ? "กรุณากรอกชื่อภาษาไทย" : "";
    case "surnameTh":
      return isBlank(v.surnameTh) ? "กรุณากรอกนามสกุลภาษาไทย" : "";
    case "nameEng":
      return isBlank(v.nameEng) ? "กรุณากรอกชื่อภาษาอังกฤษ" : "";
    case "surnameEng":
      return isBlank(v.surnameEng) ? "กรุณากรอกนามสกุลภาษาอังกฤษ" : "";

    case "cid":
      if (!v.cid) return caRequest ? "กรุณากรอกเลขประจำตัวประชาชน" : ""; // ไม่บังคับถ้าไม่ขอ CA
      if (v.cid.length !== 13) return "เลขประจำตัวประชาชนต้องมี 13 หลัก";
      if (!iDCardNumberValidator(v.cid)) return "เลขบัตรประชาชนไม่ถูกต้อง";
      return "";

    case "tel":
      if (!v.tel) return "";
      if (v.tel[0] !== "0") return "เบอร์โทรศัพท์ต้องขึ้นต้นด้วย 0";
      if (v.tel.length < 10) return "เบอร์โทรศัพท์ต้องมี 10 หลัก";
      return "";

    case "mobile":
      if (!v.mobile) return "กรุณากรอกเบอร์โทรศัพท์มือถือ";
      if (v.mobile[0] !== "0") return "เบอร์โทรศัพท์มือถือต้องขึ้นต้นด้วย 0";
      if (v.mobile.length < 10) return "เบอร์โทรศัพท์มือถือต้องมี 10 หลัก";
      return "";

    case "email":
      if (isBlank(v.email)) return "กรุณากรอกอีเมล";
      if (!EMAIL_REGEX.test(v.email)) return "รูปแบบอีเมลไม่ถูกต้อง";
      return "";

    case "username": {
      // username ไม่บังคับ แต่ถ้ากรอกต้องผ่านเงื่อนไข
      if (isBlank(v.username)) return "";
      if (v.username.length < 6) return "Username ต้องมีตัวอักษรอย่างน้อย 6 ตัว";
      if (!/^[A-Za-z0-9]+$/.test(v.username))
        return "Username ต้องเป็นตัวอักษรและตัวเลขเท่านั้น (ไม่อนุญาตตัวอักษรพิเศษ)";
      if (!/[A-Za-z]/.test(v.username)) return "Username ต้องมีตัวอักษรภาษาอังกฤษอย่างน้อย 1 ตัว";
      return "";
    }

    case "subOrganization":
      return caRequest && isBlank(v.subOrganization)
        ? "กรุณากรอกชื่อหน่วยงาน"
        : "";

    case "address":
      return caRequest && isBlank(v.address) ? "กรุณากรอกที่อยู่" : "";

    case "bizEmail":
      if (caRequest && isBlank(v.bizEmail)) return "กรุณากรอกอีเมลองค์กร";
      if (v.bizEmail && !EMAIL_REGEX.test(v.bizEmail)) return "รูปแบบอีเมลไม่ถูกต้อง";
      return "";

    default:
      return "";
  }
}